import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'

export const CancelButton = () => {
  const { resetForm } = useFormContext()

  return (
    <Button decoration="ghost" onClick={() => resetForm()}>
      {I18n.t('publisher.action.cancel')}
    </Button>
  )
}
